// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form .ant-input-group .url-schema-select.ant-select {\n  width: 90px;\n}\n.ant-input-group-addon .url-schema-select.ant-select-open .ant-select-selection,\n.ant-input-group-addon .url-schema-select.ant-select-focused .ant-select-selection {\n  color: rgba(0, 0, 0, 0.65);\n}\n", ""]);
// Exports
module.exports = exports;
